import { render, staticRenderFns } from "./ReserveSection.vue?vue&type=template&id=693ab548&scoped=true&"
import script from "./ReserveSection.vue?vue&type=script&lang=js&"
export * from "./ReserveSection.vue?vue&type=script&lang=js&"
import style0 from "./ReserveSection.vue?vue&type=style&index=0&id=693ab548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693ab548",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer})
